export const Tests = [
  {
    id: 1,
    name: "Mock Test - 100",
    questions: 100,
    time: 2,
  },
  {
    id: 2,
    name: "Mock Test - 100",
    questions: 100,
    time: 2,
  },
  {
    id: 3,
    name: "Mock Test - 100",
    questions: 100,
    time: 2,
  },
  {
    id: 4,
    name: "Mock Test - 100",
    questions: 100,
    time: 2,
  },
  {
    id: 5,
    name: "Mock Test - 100",
    questions: 100,
    time: 2,
  },
  {
    id: 6,
    name: "Mock Test - 100",
    questions: 100,
    time: 2,
  },
];

export const CLOCKRED = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_8217_2436"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_8217_2436)">
      <path
        d="M13.0004 12.6004V9.00039C13.0004 8.71706 12.9046 8.47956 12.7129 8.28789C12.5212 8.09622 12.2837 8.00039 12.0004 8.00039C11.7171 8.00039 11.4796 8.09622 11.2879 8.28789C11.0962 8.47956 11.0004 8.71706 11.0004 9.00039V12.9754C11.0004 13.1087 11.0254 13.2379 11.0754 13.3629C11.1254 13.4879 11.2004 13.6004 11.3004 13.7004L14.1004 16.5004C14.2837 16.6837 14.5171 16.7754 14.8004 16.7754C15.0837 16.7754 15.3171 16.6837 15.5004 16.5004C15.6837 16.3171 15.7754 16.0837 15.7754 15.8004C15.7754 15.5171 15.6837 15.2837 15.5004 15.1004L13.0004 12.6004ZM12.0004 22.0004C10.7504 22.0004 9.57956 21.7629 8.48789 21.2879C7.39622 20.8129 6.44622 20.1712 5.63789 19.3629C4.82956 18.5546 4.18789 17.6046 3.71289 16.5129C3.23789 15.4212 3.00039 14.2504 3.00039 13.0004C3.00039 11.7504 3.23789 10.5796 3.71289 9.48789C4.18789 8.39622 4.82956 7.44622 5.63789 6.63789C6.44622 5.82956 7.39622 5.18789 8.48789 4.71289C9.57956 4.23789 10.7504 4.00039 12.0004 4.00039C13.2504 4.00039 14.4212 4.23789 15.5129 4.71289C16.6046 5.18789 17.5546 5.82956 18.3629 6.63789C19.1712 7.44622 19.8129 8.39622 20.2879 9.48789C20.7629 10.5796 21.0004 11.7504 21.0004 13.0004C21.0004 14.2504 20.7629 15.4212 20.2879 16.5129C19.8129 17.6046 19.1712 18.5546 18.3629 19.3629C17.5546 20.1712 16.6046 20.8129 15.5129 21.2879C14.4212 21.7629 13.2504 22.0004 12.0004 22.0004ZM2.05039 7.30039C1.86706 7.11706 1.77539 6.88372 1.77539 6.60039C1.77539 6.31706 1.86706 6.08372 2.05039 5.90039L4.90039 3.05039C5.08372 2.86706 5.31706 2.77539 5.60039 2.77539C5.88372 2.77539 6.11706 2.86706 6.30039 3.05039C6.48372 3.23372 6.57539 3.46706 6.57539 3.75039C6.57539 4.03372 6.48372 4.26706 6.30039 4.45039L3.45039 7.30039C3.26706 7.48372 3.03372 7.57539 2.75039 7.57539C2.46706 7.57539 2.23372 7.48372 2.05039 7.30039ZM21.9504 7.30039C21.7671 7.48372 21.5337 7.57539 21.2504 7.57539C20.9671 7.57539 20.7337 7.48372 20.5504 7.30039L17.7004 4.45039C17.5171 4.26706 17.4254 4.03372 17.4254 3.75039C17.4254 3.46706 17.5171 3.23372 17.7004 3.05039C17.8837 2.86706 18.1171 2.77539 18.4004 2.77539C18.6837 2.77539 18.9171 2.86706 19.1004 3.05039L21.9504 5.90039C22.1337 6.08372 22.2254 6.31706 22.2254 6.60039C22.2254 6.88372 22.1337 7.11706 21.9504 7.30039ZM12.0004 20.0004C13.9504 20.0004 15.6046 19.3212 16.9629 17.9629C18.3212 16.6046 19.0004 14.9504 19.0004 13.0004C19.0004 11.0504 18.3212 9.39622 16.9629 8.03789C15.6046 6.67956 13.9504 6.00039 12.0004 6.00039C10.0504 6.00039 8.39622 6.67956 7.03789 8.03789C5.67956 9.39622 5.00039 11.0504 5.00039 13.0004C5.00039 14.9504 5.67956 16.6046 7.03789 17.9629C8.39622 19.3212 10.0504 20.0004 12.0004 20.0004Z"
        fill="red"
      />
    </g>
  </svg>
);

export const CLOCK = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_8217_2436"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_8217_2436)">
      <path
        d="M13.0004 12.6004V9.00039C13.0004 8.71706 12.9046 8.47956 12.7129 8.28789C12.5212 8.09622 12.2837 8.00039 12.0004 8.00039C11.7171 8.00039 11.4796 8.09622 11.2879 8.28789C11.0962 8.47956 11.0004 8.71706 11.0004 9.00039V12.9754C11.0004 13.1087 11.0254 13.2379 11.0754 13.3629C11.1254 13.4879 11.2004 13.6004 11.3004 13.7004L14.1004 16.5004C14.2837 16.6837 14.5171 16.7754 14.8004 16.7754C15.0837 16.7754 15.3171 16.6837 15.5004 16.5004C15.6837 16.3171 15.7754 16.0837 15.7754 15.8004C15.7754 15.5171 15.6837 15.2837 15.5004 15.1004L13.0004 12.6004ZM12.0004 22.0004C10.7504 22.0004 9.57956 21.7629 8.48789 21.2879C7.39622 20.8129 6.44622 20.1712 5.63789 19.3629C4.82956 18.5546 4.18789 17.6046 3.71289 16.5129C3.23789 15.4212 3.00039 14.2504 3.00039 13.0004C3.00039 11.7504 3.23789 10.5796 3.71289 9.48789C4.18789 8.39622 4.82956 7.44622 5.63789 6.63789C6.44622 5.82956 7.39622 5.18789 8.48789 4.71289C9.57956 4.23789 10.7504 4.00039 12.0004 4.00039C13.2504 4.00039 14.4212 4.23789 15.5129 4.71289C16.6046 5.18789 17.5546 5.82956 18.3629 6.63789C19.1712 7.44622 19.8129 8.39622 20.2879 9.48789C20.7629 10.5796 21.0004 11.7504 21.0004 13.0004C21.0004 14.2504 20.7629 15.4212 20.2879 16.5129C19.8129 17.6046 19.1712 18.5546 18.3629 19.3629C17.5546 20.1712 16.6046 20.8129 15.5129 21.2879C14.4212 21.7629 13.2504 22.0004 12.0004 22.0004ZM2.05039 7.30039C1.86706 7.11706 1.77539 6.88372 1.77539 6.60039C1.77539 6.31706 1.86706 6.08372 2.05039 5.90039L4.90039 3.05039C5.08372 2.86706 5.31706 2.77539 5.60039 2.77539C5.88372 2.77539 6.11706 2.86706 6.30039 3.05039C6.48372 3.23372 6.57539 3.46706 6.57539 3.75039C6.57539 4.03372 6.48372 4.26706 6.30039 4.45039L3.45039 7.30039C3.26706 7.48372 3.03372 7.57539 2.75039 7.57539C2.46706 7.57539 2.23372 7.48372 2.05039 7.30039ZM21.9504 7.30039C21.7671 7.48372 21.5337 7.57539 21.2504 7.57539C20.9671 7.57539 20.7337 7.48372 20.5504 7.30039L17.7004 4.45039C17.5171 4.26706 17.4254 4.03372 17.4254 3.75039C17.4254 3.46706 17.5171 3.23372 17.7004 3.05039C17.8837 2.86706 18.1171 2.77539 18.4004 2.77539C18.6837 2.77539 18.9171 2.86706 19.1004 3.05039L21.9504 5.90039C22.1337 6.08372 22.2254 6.31706 22.2254 6.60039C22.2254 6.88372 22.1337 7.11706 21.9504 7.30039ZM12.0004 20.0004C13.9504 20.0004 15.6046 19.3212 16.9629 17.9629C18.3212 16.6046 19.0004 14.9504 19.0004 13.0004C19.0004 11.0504 18.3212 9.39622 16.9629 8.03789C15.6046 6.67956 13.9504 6.00039 12.0004 6.00039C10.0504 6.00039 8.39622 6.67956 7.03789 8.03789C5.67956 9.39622 5.00039 11.0504 5.00039 13.0004C5.00039 14.9504 5.67956 16.6046 7.03789 17.9629C8.39622 19.3212 10.0504 20.0004 12.0004 20.0004Z"
        fill="#16161E"
      />
    </g>
  </svg>
);

export const QUESTIONS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_8217_2441"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_8217_2441)">
      <path
        d="M7 13H14C14.2833 13 14.5208 12.9042 14.7125 12.7125C14.9042 12.5208 15 12.2833 15 12C15 11.7167 14.9042 11.4792 14.7125 11.2875C14.5208 11.0958 14.2833 11 14 11H7C6.71667 11 6.47917 11.0958 6.2875 11.2875C6.09583 11.4792 6 11.7167 6 12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13ZM7 10H14C14.2833 10 14.5208 9.90417 14.7125 9.7125C14.9042 9.52083 15 9.28333 15 9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8H7C6.71667 8 6.47917 8.09583 6.2875 8.2875C6.09583 8.47917 6 8.71667 6 9C6 9.28333 6.09583 9.52083 6.2875 9.7125C6.47917 9.90417 6.71667 10 7 10ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z"
        fill="#16161E"
      />
    </g>
  </svg>
);
